<header class="top-navigation" role="banner" aria-label="Top navigation">
    <nav class="top-navigation__desktop-links" aria-label="Primær navigation">
        <ul class="top-navigation__list" role="list">
            @for (item of menuItems; track item) {
            <li class="top-navigation__item" role="listitem">
                <a class="top-navigation__link" [routerLink]="item.route" routerLinkActive="top-navigation__link--active" [ariaCurrentWhenActive]="'page'">
                    <mat-icon class="top-navigation__icon" [svgIcon]="item.icon" aria-hidden="true"></mat-icon>
                    <span class="top-navigation__label">{{ item.label }}</span>
                </a>
            </li>
            }
        </ul>
    </nav>
    <nav class="top-navigation__menu" aria-label="Brugermenu">
        <div class="top-navigation__content">
            <span class="top-navigation__user" aria-hidden="true">{{ userInfoData?.works?.name }}</span>
        </div>
        <div class="top-navigation__actions">
            <button
                #burgerButton
                (click)="toggleMenu(); $event.stopPropagation()"
                class="top-navigation__burger"
                featureHighlightParent="top-nav-burger"
                [attr.aria-expanded]="showMenu"
                [attr.aria-label]="showMenu ? 'Luk brugermenu' : 'Åbn brugermenu'"
                aria-controls="user-dropdown-menu"
                aria-haspopup="menu"
                type="button"
            >
                <mat-icon class="top-navigation__icon" svgIcon="account-outline" aria-hidden="true"></mat-icon>
            </button>
        </div>

        <menu
            id="user-dropdown-menu"
            role="menu"
            aria-label="Brugerhandlinger"
            [class.menu--open]="showMenu"
            [attr.aria-hidden]="!showMenu"
            [attr.inert]="showMenu ? null : ''"
            (closeMenu)="closeAndFocus()"
        >
            <user-info [data]="userInfoData" featureHighlight="highlight_Info" featureHighlightBadge="inline" />
            <button
                (click)="toggleThemeSubmenu(); $event.stopPropagation()"
                class="theme-menu-trigger"
                role="menuitem"
                type="button"
                aria-haspopup="true"
                [attr.aria-expanded]="showThemeSubmenu"
                aria-label="Tema"
            >
                <mat-icon class="top-navigation__icon" svgIcon="menu-theme" aria-hidden="true"></mat-icon>
                <span>Tema</span>
                <mat-icon
                    class="top-navigation__icon theme-menu-trigger__chevron"
                    [svgIcon]="showThemeSubmenu ? 'chevron-down' : 'chevron-right'"
                    aria-hidden="true"
                ></mat-icon>
            </button>
            @if (showThemeSubmenu) { @for (option of themeOptions; track option.mode; let i = $index) {
            <button
                (click)="selectTheme(option.mode)"
                class="theme-submenu-item"
                type="button"
                [attr.aria-checked]="activeTheme() === option.mode"
                [attr.aria-label]="option.label"
            >
                <mat-icon
                    class="top-navigation__icon theme-submenu-item__check"
                    [class.theme-submenu-item__check--hidden]="activeTheme() !== option.mode"
                    svgIcon="check"
                    aria-hidden="true"
                ></mat-icon>
                <span>{{ option.label }}</span>
            </button>
            } }

            <!-- <button
                (click)="openFeedback()"
                role="menuitem"
                type="button"
                featureHighlight="highlight_Feedback"
                featureHighlightBadge="inline"
                aria-label="Åbn feedback dialog"
            >
                <mat-icon class="top-navigation__icon" svgIcon="feedback" aria-hidden="true"></mat-icon>
                <span>Feedback</span>
            </button> -->
            @if (showMenu) { @if (teknikerPasswordFeaturesSupported$ | async) {
            <button (click)="onSkiftAdgangskode()" role="menuitem" type="button">
                <span>Skift adgangskode</span>
            </button>
            } }
            <a routerLink="/logout" role="menuitem" aria-label="Log ud af applikationen">
                <mat-icon class="top-navigation__icon" svgIcon="menu-logout" aria-hidden="true"></mat-icon>
                <span>Log ud</span>
            </a>
            <div>
                <span> Version: {{ webVersion }} ({{ klientLabel }}) </span>
            </div>
        </menu>
    </nav>
</header>
